<template>

  <div class="box">
    <div class="lun">
      <h1>123</h1>
      <div class="imgbox">
        <img :src="img"
             alt=""
             class="img1">
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'son',

  data () {
    return {
      img: require('../assets/componylogo.png')

    }
  }
}
</script>

<style scoped lang="less">
.box {
  width: 80%;
  height: 100%;
  margin: 0 auto;
  justify-content: space-between;
  display: flex;
  .lun {
    width: 100%;
    height: 95%;
    margin: auto;
    border-radius: 20px;
    display: inline-block;
    background: linear-gradient(#eeffff, #d5edfb);
    h1 {
      font-size: 39px;
      text-align: center;
      background-image: -webkit-linear-gradient(right, red, #fd8403, yellow);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .imgbox {
      height: 60%;
      .img1 {
        height: 100%;
        margin-left: 30%;
      }
      .img2 {
        height: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/son.vue